module.exports = __webpack_public_path__ + "media/images/ibjjf/membership/card-ornament-blue-primary-60651cef949cfab5702bad5b2e400e70.svg";